import routerOptions0 from "/app/node_modules/.pnpm/nuxt@3.21.2_@biomejs+biome@2.4.8_@parcel+watcher@2.5.6_@vue+compiler-sfc@3.5.30_cac@6.7_d3bd1fa78bb531ea752a2ed112e7732b/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}